import Nav from './Nav';
import checkBrowser from './../hoc/checkBrowser/checkBrowser';
export default checkBrowser(Nav);
